import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { useLang } from "@/context/LanguageContext";

export const Testimonials = () => {
  const { t } = useLang();
  const items = t.testimonials.items;
  const [i, setI] = useState(0);
  useEffect(() => { setI(0); }, [items]);
  const item = items[i];
  const go = (d) => setI((p) => (p + d + items.length) % items.length);

  return (
    <section className="py-24 md:py-32 bg-[#EDECE6] border-y border-[#E2E0D8]">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="overline text-[#C4A484] mb-10 text-center">{t.testimonials.overline}</motion.p>

        <div className="relative min-h-[280px] flex items-center">
          <AnimatePresence mode="wait">
            <motion.blockquote key={i} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -24 }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} className="text-center" data-testid="testimonial-quote">
              <p className="font-serif text-2xl md:text-4xl leading-[1.25] text-[#0D2A27]">&ldquo;{item.quote}&rdquo;</p>
              <footer className="mt-10">
                <p className="font-semibold text-[#0D2A27]">{t.testimonials.anonLabel}</p>
                <p className="text-sm text-[#555] mt-1">{item.city} · {item.treatment}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center justify-center gap-4">
          <button onClick={() => go(-1)} data-testid="testimonial-prev" className="h-11 w-11 rounded-full border border-[#0D2A27]/25 text-[#0D2A27] transition-colors duration-300 hover:bg-[#0D2A27] hover:text-[#F7F6F2]">←</button>
          <div className="flex gap-2">
            {items.map((_, idx) => (
              <button key={idx} onClick={() => setI(idx)} aria-label={`Story ${idx + 1}`} className={`h-2 rounded-full transition-all duration-300 ${idx === i ? "w-8 bg-[#0D2A27]" : "w-2 bg-[#0D2A27]/25"}`} />
            ))}
          </div>
          <button onClick={() => go(1)} data-testid="testimonial-next" className="h-11 w-11 rounded-full border border-[#0D2A27]/25 text-[#0D2A27] transition-colors duration-300 hover:bg-[#0D2A27] hover:text-[#F7F6F2]">→</button>
        </div>
      </div>
    </section>
  );
};
